import { defineStore } from 'pinia';
import { getSellerDeposit } from '@/api/seller';

interface SellerDepositState {
  amount: number | null
  amountText: string
  siteSellerDeposit: number
  siteSellerDepositText: number
  paySellerDeposit: number
  paySellerDepositText: number
  deposit: number
  depositText: string
}

export const useSellerDeposit = defineStore({
  id: 'seller-deposit',
  state: (): SellerDepositState => ({
    amount: null,
    amountText: '',
    siteSellerDeposit: 0,
    siteSellerDepositText: 0,
    paySellerDeposit: 0,
    paySellerDepositText: 0,
    deposit: 0,
    depositText: '',
  }),
  getters: {},
  actions: {
    async getBoothDeposit() {
      const res = await getSellerDeposit();
      this.amount = res.amount;
      this.amountText = res.amount_text;
      this.siteSellerDeposit = res.site_seller_deposit;
      this.siteSellerDepositText = res.site_seller_deposit_text;
      this.paySellerDeposit = res.pay_seller_deposit;
      this.paySellerDepositText = res.pay_seller_deposit_text;
      this.deposit = res.deposit;
      this.depositText = res.deposit_text;
    },
  },
});
